import React, { Component } from 'react';
import PropTypes from 'prop-types'
import {footerItems} from '../dummy_data/localizationItems.json'

class SimpleFooter extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired
	}

	getField = (fieldName) =>{
		return localStorage.getItem("isEnglish") === "true"? footerItems.find(i => i.fieldName === fieldName).eName : footerItems.find(i => i.fieldName === fieldName).name;
	}

	render() {
		const { PhoneNumber1, PhoneNumber2, Fax, Address1, Address2, Weibo, Wechat, QQ, QRCode } = this.props.item;
		return(
			<footer>
				<div className="footer-container-simple">
					<div>
						<ul className="contact-info-simple">
					    	<li className="margin-right-10"><i className="fa fa-phone" aria-hidden="true"></i>{this.getField("PhoneNumber1")}: {PhoneNumber1}</li>
						  	<li className="margin-right-10"><i className="fa fa-fax" aria-hidden="true"></i>{this.getField("Fax")}：{Fax}</li>
						  	<li className="margin-right-10"><i className="fa fa-fax" aria-hidden="true"></i>{this.getField("Address1")}: {Address1}</li>
						  	<li><i className="fa fa-location-arrow" aria-hidden="true"></i>{this.getField("Address2")}: {Address2}</li>
						</ul>
					</div>
					
					<div className="lower-footer-block">
			            <span className="copyright">版权所有© 欧绅维尔集团 1991-2018 鲁ICP备18010741号</span>
			        </div>
			    </div>
			</footer>
		);
	}
}

export default SimpleFooter;


// WEBPACK FOOTER //
// ./src/components/SimpleFooter.js